<template>
    <div class="nav">
        <div :class="current == 0 ? 'nav-item-active' : 'nav-item'" @click="switchCurrent(0)">
            <div :class="current == 0 ? 'nav-item-active-icon' : 'nav-item-icon'">
                <img v-if="current == 0" src="../images/ai-active.png" alt="">
                <img v-else src="../images/ai.png" alt="">
            </div>
            <div :class="current == 0 ? 'nav-item-active-title' : 'nav-item-title'">首页</div>
        </div>
        <div :class="current == 1 ? 'nav-item-active' : 'nav-item'" @click="switchCurrent(1)">
            <div :class="current == 1 ? 'nav-item-active-icon' : 'nav-item-icon'">
                <img v-if="current == 1" src="../images/mentou-active.png" alt="">
                <img v-else src="../images/mentou.png" alt="">
            </div>
            <div :class="current == 1 ? 'nav-item-active-title' : 'nav-item-title'">餐饮店</div>
        </div>
        <!-- <div :class="current == 2 ? 'nav-item-active' : 'nav-item'" @click="switchCurrent(2)">
            <div :class="current == 2 ? 'nav-item-active-icon' : 'nav-item-icon'">
                <img v-if="current == 2" src="../images/mentou-active.png" alt="">
                <img v-else src="../images/mentou.png" alt="">
            </div>
            <div :class="current == 2 ? 'nav-item-active-title' : 'nav-item-title'">商场店</div>
        </div> -->
        <div :class="current == 3 ? 'nav-item-active' : 'nav-item'" @click="switchCurrent(3)">
            <div :class="current == 3 ? 'nav-item-active-icon' : 'nav-item-icon'">
                <img v-if="current == 3" src="../images/mentou-active.png" alt="">
                <img v-else src="../images/mentou.png" alt="">
            </div>
            <div :class="current == 3 ? 'nav-item-active-title' : 'nav-item-title'">服装店</div>
        </div>
        <div :class="current == 4 ? 'nav-item-active' : 'nav-item'" @click="switchCurrent(4)">
            <div :class="current == 4 ? 'nav-item-active-icon' : 'nav-item-icon'">
                <img v-if="current == 4" src="../images/xianchang-active.png" alt="">
                <img v-else src="../images/xianchang.png" alt="">
            </div>
            <div :class="current == 4 ? 'nav-item-active-title' : 'nav-item-title'">现场还原</div>
        </div>
        <div :class="current == 5 ? 'nav-item-active' : 'nav-item'" @click="switchCurrent(5)">
            <div :class="current == 5 ? 'nav-item-active-icon' : 'nav-item-icon'">
                <img v-if="current == 5" src="../images/sheji-active.png" alt="">
                <img v-else src="../images/sheji.png" alt="">
            </div>
            <div :class="current == 5 ? 'nav-item-active-title' : 'nav-item-title'">设计案例</div>
        </div>
        <div :class="current == 6 ? 'nav-item-active' : 'nav-item'" @click="switchCurrent(6)" v-if=" store.getters.userInfo  &&  store.getters.userInfo.username == 'a3514378'">
            <div :class="current == 6 ? 'nav-item-active-icon' : 'nav-item-icon'">
                <img v-if="current == 6" src="../images/sheji-active.png" alt="">
                <img v-else src="../images/sheji.png" alt="">
            </div>
            <div :class="current == 6 ? 'nav-item-active-title' : 'nav-item-title'">分类管理</div>
        </div>
        <div :class="current == 7 ? 'nav-item-active' : 'nav-item'" @click="switchCurrent(7)">
            <div :class="current == 7 ? 'nav-item-active-icon' : 'nav-item-icon'">
                <img v-if="current == 7" src="../images/lianxi-active.png" alt="">
                <img v-else src="../images/lianxi.png" alt="">
            </div>
            <div :class="current == 7 ? 'nav-item-active-title' : 'nav-item-title'">联系我们</div>
        </div>
        <div :class="current == 8 ? 'nav-item-active' : 'nav-item'" @click="switchCurrent(8)">
            <div :class="current == 8 ? 'nav-item-active-icon' : 'nav-item-icon'">
                <img v-if="current == 8" src="../images/sheji-active.png" alt="">
                <img v-else src="../images/sheji.png" alt="">
            </div>
            <div :class="current == 8 ? 'nav-item-active-title' : 'nav-item-title'">图片简介</div>
        </div>
        <div :class="current == 9 ? 'nav-item-active' : 'nav-item'" @click="switchCurrent(9)" v-if="store.getters.isLoggedIn">
            <div :class="current == 9 ? 'nav-item-active-icon' : 'nav-item-icon'">
                <img v-if="current == 9" src="../images/sheji-active.png" alt="">
                <img v-else src="../images/sheji.png" alt="">
            </div>
            <div :class="current == 9 ? 'nav-item-active-title' : 'nav-item-title'">在线充值</div>
        </div>
    </div>

</template>

<script setup>
import { onMounted, ref, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
const store =useStore();
const router = useRouter();
const route = useRoute();

const itemList = ref([
    { name: '首页', route: '/', id: 0, icon: '../images/ai.png', selectIcon: '../images/ai-active.png' },
    { name: '餐饮店', route: '/design', id: 1, icon: '../images/mentou.png', selectIcon: '../images/mentou-active.png' },
    { name: '商场店', route: '/mall', id: 2, icon: '../images/mentou.png', selectIcon: '../images/mentou-active.png' },
    { name: '服装店', route: '/clothing', id: 3, icon: '../images/mentou.png', selectIcon: '../images/mentou-active.png' },
    { name: '现场还原', route: '/restore', id: 4, icon: '../images/xianchang.png', selectIcon: '../images/xianchang-active.png' },
    { name: '设计案例', route: '/cases', id: 5, icon: '../images/sheji.png', selectIcon: '../images/sheji-active.png' },
    { name: '分类管理', route: '/category', id: 6, icon: '../images/sheji.png', selectIcon: '../images/sheji-active.png' },
    { name: '联系我们', route: '/contact', id: 7, icon: '../images/lianxi.png', selectIcon: '../images/lianxi-active.png' },
    { name: '图片简介', route: '/image-brief', id: 8, icon: '../images/sheji.png', selectIcon: '../images/sheji-active.png' },
    { name: '在线充值', route: '/recharge', id: 9, icon: '../images/sheji.png', selectIcon: '../images/sheji-active.png' },
]);

// 根据当前路由设置选中的菜单项
const current = ref(0);

// 监听路由变化，更新当前选中项
watch(() => route.path, (newPath) => {
    const item = itemList.value.find(item => item.route === newPath);
    if (item) {
        current.value = item.id;
    } else if (newPath === '/') {
        current.value = 0;
    }
}, { immediate: true });

const switchCurrent = (item) => {
    current.value = item;
    const route = itemList.value.filter(i=>i.id == item);
    // 使用路由跳转
    router.push(route[0].route);
}
let userInfo = ref(null);
onMounted(() => {
  userInfo.value = store.getters.userInfo;
  console.log(userInfo.value);
  
});
</script>


<style lang="less" scoped>
.nav-item {
    margin-top: 8px;
    width: 175px;
    height: 46px;
    border-radius: 40px 40px 40px 40px;
    display: flex;
    align-items: center;
    cursor: pointer;

    &-icon {
        margin-left: 16px;
        margin-top: 4px;

    }

    &-title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 16px;
        color: #FFFFFF;
        margin-left: 16px;
    }
}

.nav-item-active {
    margin-top: 8px;
    width: 175px;
    height: 46px;
    background: linear-gradient(90deg, #4D4D4D 0%, rgba(54, 54, 54, 0) 100%);
    border-radius: 40px 40px 40px 40px;
    display: flex;
    align-items: center;
    cursor: pointer;

    &-icon {
        margin-left: 16px;
        margin-top: 4px;
    }

    &-title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 16px;
        color: #5EFF00;
        margin-left: 16px;

    }
}
</style>